// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recruitment-main {
  height: calc(100vh - 65px);
  overflow-y: scroll;
  padding-top: 20px;
  padding-bottom: 15px;
}
.color-black {
  color: rgb(30, 30, 30);
}

.color-grey {
  color: rgb(128, 128, 128) !important;
}

.rys-table {
  background-color: white;
  border-radius: 15px;
  border: 2px solid #2cded3;
  border-top: 50px solid #2cded3;
}

.rys-table table {
  margin-top: -42px;
}

.rys-table thead {
  background-color: #2cded3;
}
.rys-table thead tr th {
  color: white;
  border-color: #2cded3 !important;
}
.rys-table thead tr th span {
  font-weight: 700 !important;
  vertical-align: middle;
}

.btn.btn-nv {
  background-color: rgb(123, 107, 228);
  color: white;
}

.header-bg-blue {
  background-color: #41c8ff;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

.header-bg-grey {
  background-color: #dadadadd;
  margin-left: -1px;
  border-top-left-radius: 15px !important;
  border-top-right-radius: 15px !important;
  border: 2px solid #dadadadd;
}

.window-vacante-process {
  border: 2px solid #dadadadd;
  border-radius: 15px;
  background-color: #f9f9f9de;
  padding-left: 0.6rem !important;
  padding-right: 0.7rem !important;
}
.vacante-title-in-window-process {
  font-size: 1.75rem;
  font-weight: 600;
  vertical-align: middle;
}

.img-rys-process {
  max-width: 60px;
  margin-top: -10px;
  margin-bottom: -10px;
}

.response-menu {
  background-color: white;
}

.list-item {
  cursor: pointer;
}

.selected-item {
  background-color: #6d68aa !important;
  color: white !important;
}

.post-button {
  background-color: #6d68aa !important;
  color: white !important;
  font-weight: 600 !important;
  transition: all 1.2s ease-in-out;
}
.post-button:hover {
  background-color: #3f3c64 !important;
  transform: scale(1.1);
}
`, "",{"version":3,"sources":["webpack://./src/Views/RecruitmentAndSelection/styles.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,uCAAuC;EACvC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":[".recruitment-main {\n  height: calc(100vh - 65px);\n  overflow-y: scroll;\n  padding-top: 20px;\n  padding-bottom: 15px;\n}\n.color-black {\n  color: rgb(30, 30, 30);\n}\n\n.color-grey {\n  color: rgb(128, 128, 128) !important;\n}\n\n.rys-table {\n  background-color: white;\n  border-radius: 15px;\n  border: 2px solid #2cded3;\n  border-top: 50px solid #2cded3;\n}\n\n.rys-table table {\n  margin-top: -42px;\n}\n\n.rys-table thead {\n  background-color: #2cded3;\n}\n.rys-table thead tr th {\n  color: white;\n  border-color: #2cded3 !important;\n}\n.rys-table thead tr th span {\n  font-weight: 700 !important;\n  vertical-align: middle;\n}\n\n.btn.btn-nv {\n  background-color: rgb(123, 107, 228);\n  color: white;\n}\n\n.header-bg-blue {\n  background-color: #41c8ff;\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n}\n\n.header-bg-grey {\n  background-color: #dadadadd;\n  margin-left: -1px;\n  border-top-left-radius: 15px !important;\n  border-top-right-radius: 15px !important;\n  border: 2px solid #dadadadd;\n}\n\n.window-vacante-process {\n  border: 2px solid #dadadadd;\n  border-radius: 15px;\n  background-color: #f9f9f9de;\n  padding-left: 0.6rem !important;\n  padding-right: 0.7rem !important;\n}\n.vacante-title-in-window-process {\n  font-size: 1.75rem;\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.img-rys-process {\n  max-width: 60px;\n  margin-top: -10px;\n  margin-bottom: -10px;\n}\n\n.response-menu {\n  background-color: white;\n}\n\n.list-item {\n  cursor: pointer;\n}\n\n.selected-item {\n  background-color: #6d68aa !important;\n  color: white !important;\n}\n\n.post-button {\n  background-color: #6d68aa !important;\n  color: white !important;\n  font-weight: 600 !important;\n  transition: all 1.2s ease-in-out;\n}\n.post-button:hover {\n  background-color: #3f3c64 !important;\n  transform: scale(1.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
